export const getUserSurveys = (state) => (id) => {
  const now = new Date();

  return state.surveys
    .filter((x) => x.invitees.includes(id))
    .filter((x) => {
      return x.open.from.toDate() <= now && x.open.to.toDate() >= now;
    });
};

export const singleSurvey = (state) => (id) => {
  return state.surveys.find((x) => x.id === id);
};

export const singleSurveyResults = (state) => {
  const rawResults = state.currentSurveyResults;
  const results = Object.keys(rawResults).map((x) => {
    return rawResults[x].answers;
  });
  return results;
};
